export default __webpack_public_path__ + "static/popup-form-cb6470ffd51ccd7b47bd22a1cee92873.png";